import {createStore, combineReducers, applyMiddleware, compose} from "redux"
import thunk from 'redux-thunk'
import {reportReducer} from "./dailyReport/reducers"
import {operationReducer} from "./infoList/reducers"

const rootReducer = combineReducers({
  dailyReport: reportReducer,
  operationMessages: operationReducer
})
const middleware = [thunk]

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
//开发环境配置devtool
export const store = createStore(
  rootReducer,
  process.env.NODE_ENV === "production" ? applyMiddleware(...middleware) : composeEnhancers(applyMiddleware(...middleware))
)

